import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from '../../mixins/translate/translate';
import { replaceItems } from '../../utils/replaceItems';
import { appContext } from '../appContext';

interface IErrorProps {
    sentryEventId?: string | undefined;
}

export function GeneralError(props: IErrorProps) {
    const translate = useTranslate();

    return (
        <appContext.Consumer>
            {(appState) => {
                const {
                    emailAddress,
                    globalSettings: { sendBugReportLink },
                } = appState;
                const formattedBugReportLink = replaceItems(sendBugReportLink, [
                    { search: '{email}', replace: emailAddress ?? 'not logged in' },
                    { search: '{errorId}', replace: `Error id: ${props.sentryEventId}` },
                ]);
                return (
                    <div>
                        <header id="topbar" className="ph10">
                            <div className="topbar-left">
                                <ol className="breadcrumb">
                                    <li className="crumb-active">
                                        <span className="fa fa-bug pr10 fs18"></span>
                                        <span className="fs18">Error</span>
                                    </li>
                                </ol>
                            </div>
                        </header>

                        <section id="content" className="mt20">
                            <div className="tray tray-center">
                                <div className="admin-form theme-primary mw700 center-block" style={{ paddingBottom: '175px' }}>
                                    <div className="panel heading-border">
                                        <div className="panel-header">
                                            <div className="p25">
                                                <h2 className="fw200">
                                                    <span className="fa fa-warning text-warning pr10 fs24"></span>{' '}
                                                    {translate('errorPages.generalTitle')}
                                                </h2>
                                            </div>
                                        </div>
                                        <div className="panel-body  bg-light">
                                            <p>{translate('errorPages.generalBody')}</p>
                                            <p>
                                                {translate('errorPages.generalBody2')}
                                                <Link to="/dashboard">{translate('errorPages.goToDashboard')}</Link>.
                                            </p>
                                            <p>&nbsp;</p>
                                            <p>
                                                {translate('errorPages.needHelp')}{' '}
                                                <a href={formattedBugReportLink} target="_blank" rel="noreferrer" className="link">
                                                    {translate('errorPages.generalSendEmail')}
                                                </a>
                                            </p>
                                            <p>&nbsp;</p>
                                            <p>
                                                {translate('errorPages.errorRegistration')} {props.sentryEventId}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                );
            }}
        </appContext.Consumer>
    );
}
